"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("./utils");
var core_1 = require("@material-ui/core");
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
function SimpleTableRows(_a) {
    var rowsData = _a.rowsData, variant = _a.variant, tableXLength = _a.tableXLength, disableAutoAlign = _a.disableAutoAlign, alternateRowColors = _a.alternateRowColors;
    var classes = useStyles();
    var _b = react_1.useState([]), openedCollapsibles = _b[0], setOpenedCollapsibles = _b[1];
    /**
     * align the last cell right if not disabled
     *
     * @param index
     * @param length
     */
    var autoAlign = function (index, length) {
        return disableAutoAlign ? undefined : index + 1 === length ? 'right' : 'left';
    };
    var renderedRows = rowsData.map(function (cellsData, i) {
        var _a;
        var _b;
        var EmptyCells = function () {
            var numberOfCells = 0;
            if (utils_1.isCollapsibleDataForTable(cellsData)) {
                if (variant === 'body') {
                    // we are adding a cell with the dropdown iconbutton
                    numberOfCells = Object.keys(cellsData.main).length + 1;
                }
                else {
                    numberOfCells = Object.keys(cellsData.main).length;
                }
            }
            else {
                numberOfCells = Object.keys(cellsData).length;
            }
            return Array.from({
                length: tableXLength - numberOfCells,
            }).map(function (_, i) { return jsx_runtime_1.jsx(core_1.TableCell, {}, i); });
        };
        var firstEntry;
        if (!utils_1.isCollapsibleDataForTable(cellsData)) {
            firstEntry = utils_1.transformCellData(cellsData[0]);
        }
        var key = (firstEntry === null || firstEntry === void 0 ? void 0 : firstEntry.key) || String(firstEntry === null || firstEntry === void 0 ? void 0 : firstEntry.value) + i;
        var isOpen = openedCollapsibles.includes(i);
        var closeCollapsible = function () {
            return setOpenedCollapsibles(__spreadArrays(openedCollapsibles.filter(function (el) { return el !== i; })));
        };
        var openCollapsible = function () { return setOpenedCollapsibles(__spreadArrays(openedCollapsibles, [i])); };
        return utils_1.isCollapsibleDataForTable(cellsData) ? (jsx_runtime_1.jsxs(react_1.Fragment, { children: [jsx_runtime_1.jsxs(__1.TableRow, __assign({ onClick: function () {
                        if (isOpen) {
                            closeCollapsible();
                        }
                        else {
                            openCollapsible();
                        }
                    } }, { children: [cellsData.main.map(function (cellData, index) {
                            var _a = utils_1.transformCellData(cellData), value = _a.value, colSpan = _a.colSpan, rowSpan = _a.rowSpan, align = _a.align, width = _a.width, height = _a.height, overrideVariant = _a.variant, className = _a.className;
                            return (jsx_runtime_1.jsx(core_1.TableCell, __assign({ className: className, variant: overrideVariant || variant, colSpan: colSpan, rowSpan: rowSpan, width: width, height: height, align: align || autoAlign(index, cellsData.main.length) }, { children: value }), String(value) + index));
                        }), EmptyCells(), jsx_runtime_1.jsx(core_1.TableCell, __assign({ align: "right" }, { children: jsx_runtime_1.jsx(__1.IconButton, __assign({ "aria-label": "expand row", size: "small", onClick: function () {
                                    if (isOpen) {
                                        closeCollapsible();
                                    }
                                    else {
                                        openCollapsible();
                                    }
                                } }, { children: isOpen ? jsx_runtime_1.jsx(__1.Icon.KeyboardArrowUp, {}, void 0) : jsx_runtime_1.jsx(__1.Icon.KeyboardArrowDown, {}, void 0) }), void 0) }), void 0)] }), void 0),
                jsx_runtime_1.jsx(__1.TableRow, __assign({ className: alternateRowColors && variant === 'body' && i % 2 === 0
                        ? classes.alternatedRow
                        : undefined }, { children: jsx_runtime_1.jsx(core_1.TableCell, __assign({ className: "" + (utils_1.isCollapsibleWithClasses(cellsData.collapsible)
                            ? cellsData.collapsible.className
                            : classes.collapsibleTableCell), colSpan: cellsData.main.length + 1 }, { children: jsx_runtime_1.jsx(__1.Collapse, __assign({ in: isOpen, timeout: "auto", unmountOnExit: true }, { children: jsx_runtime_1.jsx(__1.Box, __assign({ margin: 1 }, { children: utils_1.isCollapsibleWithClasses(cellsData.collapsible)
                                    ? cellsData.collapsible.body
                                    : cellsData.collapsible }), void 0) }), void 0) }), void 0) }), void 0)] }, key)) : (jsx_runtime_1.jsxs(__1.TableRow, __assign({ className: classnames_1.default((_a = {},
                _a[classes.alternatedRow] = alternateRowColors && variant === 'body' && i % 2 === 0,
                _a)) }, { children: [cellsData.map(function (cellData, index) {
                    var _a = utils_1.transformCellData(cellData), value = _a.value, colSpan = _a.colSpan, rowSpan = _a.rowSpan, align = _a.align, width = _a.width, height = _a.height, className = _a.className, overrideVariant = _a.variant;
                    return (jsx_runtime_1.jsx(core_1.TableCell, __assign({ variant: overrideVariant || variant, colSpan: colSpan, rowSpan: rowSpan, width: width, height: height, align: align || autoAlign(index, cellsData.length), className: className }, { children: value }), String(value) + index));
                }),
                typeof cellsData[0] !== 'string'
                    ? ((_b = cellsData[0]) === null || _b === void 0 ? void 0 : _b.colSpan) ? null
                        : EmptyCells()
                    : EmptyCells()] }), key));
    });
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: renderedRows }, void 0);
}
exports.default = SimpleTableRows;
var useStyles = core_1.makeStyles({
    alternatedRow: {
        background: 'rgba(0,0,0,0.05)',
    },
    collapsibleTableCell: {
        paddingBottom: 0,
        paddingTop: 0,
    },
});
//# sourceMappingURL=SimpleTableRow.js.map